import Vue from 'vue';
import Vuex from 'vuex';
import {isEmpty} from 'lodash-es';

//import utilities from '@/Utilities/common';

Vue.use(Vuex);

export const store = new Vuex.Store({
    strict: true,
    state: {
        blocks: null,
        modalState: 'closed', // modal's default state 
    },
    mutations: {
        blocks(state, payload) {
            //console.log('block payload: ', payload);
            if(payload && !isEmpty(payload)) {
                state.blocks = typeof payload === 'object' ? Object.keys(payload).map((k) => payload[k]) : payload;
            }
        },
        modalState(state, payload) {
            state.modalState = payload;
        },
    },
    actions: {
        setBlocks(context, payload) {
            //console.log('setBlocks ', payload);
            if(payload.claimParams){
                for(let k in payload.blocks){
                    const data = payload.blocks[k].diamond.data;
                    // get last item
                    let info = data[data.length - 1];
                    // update params
                    if(info.claimParams){
                        // join params: "info" has offer key/id and payload has "meta"
                        Object.assign(info.claimParams, payload.claimParams);
                        // update last item
                        payload.blocks[k].diamond.data[data.length - 1] = info;
                        //console.log('new info', info);
                    }
                }    
            }
            //console.log('setBlocks ', payload.blocks);
            context.commit('blocks', payload.blocks);
        },
        setModalState(context, payload){
            context.commit('modalState', payload);
        },
    },
    getters: {
        blocks: state => state.blocks,
        modalState: state => state.modalState,
    },
});
